import { RotateCcw } from "lucide-react";
import { Button } from "@/components/form/Button";

/**
 * The month or its briefs did not load (DESIGN.md "The Centred State Rule"):
 * the glyph, one line and Try again, centred in the space the page stands in.
 */
export default function MonthLoadError({ onRetry, minHeight = "100dvh" }: { onRetry: () => void; minHeight?: string }) {
  return (
    <div className="grid place-items-center px-6" style={{ minHeight }}>
      <div role="alert" className="flex max-w-[380px] flex-col items-center gap-3 text-center">
        <span className="grid size-11 place-items-center rounded-card border border-co-line2 text-co-muted">
          <RotateCcw className="size-5" strokeWidth={1.6} aria-hidden="true" />
        </span>
        <p className="font-section text-[22px] font-bold text-co-text">This month could not load</p>
        <p className="text-[14px] leading-relaxed text-co-muted">Check your connection, then try again.</p>
        <Button size="small" variant="secondary" buttonStyle="outline" onPress={onRetry}>
          Try again
        </Button>
      </div>
    </div>
  );
}
